<template>
  <div :class="classes" class="flex justify-center w-full">
    <div class="w-full flex justify-between bg-white dark:bg-lh_red px-8 py-4">
      <router-link to="/" class="w-[8vh] lg:w-[6vw] flex items-center h-fit">
        <img alt="logo" :src="navbarItems.logo" class="dark:hidden block" />
        <img alt="logo" :src="navbarItems.whiteLogo" class="hidden dark:block" />
      </router-link>
      <navbar-buttons class="w-2/3 lg:w-fit" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import appVariables from '@/config/appVariables.json';
import NavbarButtons from './NavbarButtons.vue';

export default {
  components: {
    NavbarButtons,
  },
  data() {
    return {
      caseClass: {
        uppercase: 'uppercase',
        lowercase: 'lowercase',
        capitalize: 'capitalize',
      },
      weightClass: {
        light: 'font-light',
        normal: 'font-normal',
        bold: 'font-bold',
      },
      directionClass: {
        horizontal: 'flex flex-row space-x-4',
        vertical: 'flex flex-col space-y-2',
      },
      showNavbar: false,
      navbarItems: appVariables,
    };
  },
  props: {
    fontCase: {
      type: String,
      default: 'uppercase',
    },
    direction: {
      type: String,
      default: 'horizontal',
    },
    mobileDirection: {
      type: String,
      default: 'vertical',
    },
    fontWeight: {
      type: String,
      default: 'light',
    },
    elementsColor: {
      type: String,
      default: 'text-black dark:text-white bg-white dark:bg-slate-800',
    },
    slideCart: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.startColorMode();
  },
  computed: {
    ...mapGetters('auth', ['authenticated', 'isSuperAdmin']),
    ...mapGetters('cart', ['productsCount']),
    classes() {
      // eslint-disable-next-line max-len
      return `${this.caseClass[this.fontCase]} ${this.directionClass[this.direction]} ${this.weightClass[this.fontWeight]} ${this.elementsColor}`;
    },
    mobileClasses() {
      // eslint-disable-next-line max-len
      return `${this.caseClass[this.fontCase]} ${this.directionClass[this.mobileDirection]} ${this.weightClass[this.fontWeight]} ${this.elementsColor}`;
    },
  },
  methods: {
    ...mapActions('auth', ['signOut']),
    openCloseNavbar() {
      this.showNavbar = !this.showNavbar;
    },
    startColorMode() {
      const lsTheme = localStorage.getItem('theme');
      this.setColorMode(lsTheme);
    },
    toggleDarkMode() {
      const lsTheme = localStorage.getItem('theme') === 'dark' ? 'light' : 'dark';
      this.setColorMode(lsTheme);
    },
    setColorMode(lsTheme) {
      const element = document.body;
      element.removeAttribute('class');
      element.classList.add(lsTheme);
      localStorage.setItem('theme', lsTheme);
    },
    async doAction() {
      if (!this.authenticated) {
        this.$router.push('/sign-in');
        return;
      }
      await this.signOut();
      this.$router.push('/');
    },
  },
};
</script>

<style>
.slide-fade-enter-active {
  transition: all 0.5s ease-in-out;
}

.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(-20px);
  opacity: 0;
}

</style>
